import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { TradingEntityMetaDetail, CrudEventEnum, TradingEntityMeta, TradingEntityAliasType } from 'api'
import { DataGrid, GridId, GridAutoSizing } from 'view/components/datagrid'
import {
  tradingEntityDefaultsGridOptions,
  tradingEntityDefaultsColumnDefs,
  TradingEntityDefaultsUpdateFields
} from './tradingEntityDefaultsGridModel'
import { tradingEntityMetaDetailsSelector } from 'selectors/tradingEntitySelectors'
import { NEW_ITEM_PREFIX, notEmpty } from 'utils'
import { createTradingEntityUpdateMetaAction } from 'model/tradingEntityMetaUtils'
import { TradingEntityDefaultsGroupByToggles } from './TradingEntityDefaultsGroupByToggles'

interface TradingEntityDefaultsGridProps {
  tradingEntityMetaList: TradingEntityMetaDetail[]
  onUpdate: (tradingEntityMeta: TradingEntityMeta) => unknown
}

const mapStateToProps = createStructuredSelector({
  tradingEntityMetaList: tradingEntityMetaDetailsSelector
})

const mapDispatchToProps = {
  onUpdate: createTradingEntityUpdateMetaAction
}

export const TradingEntityDefaultsGridComponent: React.FunctionComponent<TradingEntityDefaultsGridProps> = props => {
  const { tradingEntityMetaList, onUpdate } = props

  const canEditRow = (tradingEntityMetaDetail: TradingEntityMetaDetail) =>
    tradingEntityMetaDetail.availableEvents.includes(CrudEventEnum.UPSERT)

  const handleCellValueUpdated = (_rowId: string, tradingEntityMetaDetail: TradingEntityMetaDetail, field: string, newValue: string) => {
    const tradingEntityMetaId = tradingEntityMetaDetail.tradingEntityMeta.id
    const tradingEntityMeta: TradingEntityMeta = {
      ...tradingEntityMetaDetail.tradingEntityMeta,
      id: tradingEntityMetaId.startsWith(NEW_ITEM_PREFIX) ? '' : tradingEntityMetaId,
      ...(field === TradingEntityDefaultsUpdateFields.ALIAS && {
        aliasTypeAndValues: notEmpty(newValue) ? [{ value: newValue, type: TradingEntityAliasType.ALL }] : []
      })
    }
    onUpdate(tradingEntityMeta)
  }

  return (
    <DataGrid
      gridId={GridId.TradingEntityAliasGrid}
      gridOptions={tradingEntityDefaultsGridOptions}
      gridColumnAutoSizing={GridAutoSizing.NONE}
      columnDefs={tradingEntityDefaultsColumnDefs}
      rowData={tradingEntityMetaList}
      canEditRow={canEditRow}
      onCellValueUpdated={handleCellValueUpdated}
      GroupByToggles={TradingEntityDefaultsGroupByToggles}
      disableGrouping={true}
    />
  )
}

export const TradingEntityDefaultsGrid = connect(mapStateToProps, mapDispatchToProps)(TradingEntityDefaultsGridComponent)
